import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";
import { ReactComponent as SettingsIcon } from "../../../assets/svg/settings.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const Settings = () => {
    const dispatch = useDispatch();
    const packageObj = useSelector((state) => state.globalReducer.packageObj);

    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                explore_settings: 1,
            },
        };
        localStorage.setItem("activeModule", "Listening");
        dispatch(setActiveModule("Listening"));
        dispatch(configure_getting_started_progress(obj));
    };
    let path = packageObj?.package_code !== "enterprise" ? "/settings/filters" : "/settings/block-source";
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <SettingsIcon className="icon_content fill_svg" />
                        <span className="content_title">Settings</span>
                    </div>
                    <div className="text_content">
                        <p>{`You can access various sections from Settings.  The sections which are available are`}</p>
                        {packageObj?.package_code !== "enterprise" ? (
                            <>
                                <p>1. Filters - Useful to filter data in your dashboards</p>
                                <p>2. User Management - Create users and manage their permissions</p>
                            </>
                        ) : (
                            <>
                                <p>1. Block Source - Useful to block out sources from which you do not want to see any data</p>
                                <p>2. Filters - Useful to filter data in your dashboards</p>
                                <p>3. Word Cloud - Add words that you do not wish to see in the word cloud. View a list of all blocked words</p>
                                <p>4. User Management - Create users and manage their permissions</p>
                                {/* <p>5. Login Logs - View login activity for all the users</p> */}
                                <p>5. Logo - Upload or change your company logo here.</p>
                                <p>6. Image Analytics - Settings related to image recognition and custom image models</p>
                            </>
                        )}

                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to={path}>
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>

                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/4iGl8MPghM8"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default Settings;
